import { render, staticRenderFns } from "./stage_test_component.vue?vue&type=template&id=2f145c11&"
import script from "./stage_test_component.vue?vue&type=script&lang=js&"
export * from "./stage_test_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports